/**
 * Update the parallaxing background img to partially scroll
 */

jQuery(document).ready(function($) {
    $(window).on('scroll', function() {
        $('.parallax').each(function(index, el) {
            var $el = $(el);
            var fromTop = $el.offset().top + ($el.outerHeight() / 2) - $(window).scrollTop();
            var windowHeight = $(window).height();
            var percent = (fromTop * 100 / windowHeight);

            $el.css('background-position', '0 ' + percent + '%');
        });
    });
});
